<div class="cross-wrapper">
    <div class="close" (click)="submitFeedback()">&#10005;</div>
</div>

<form [formGroup]="feedbackReview">
    <span>Please tell us what went wrong. We promise to work hard and make it right.</span>
    <textarea formControlName="reviewTextArea" placeholder="{{ placeholder }}" maxlength="1024"></textarea>
</form>

<button btn-primary size="full" (click)="submitFeedback()">Submit Feedback</button>
